import 'twin.macro'

import { Ring } from '@uiball/loaders'
import { ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

type InfoBlockProps = {
  children: ReactNode
  twStyle?: TwStyle | Array<TwStyle | undefined>
  className?: string
  isContentLoading?: boolean
}

const InfoBlock = ({ children, className, isContentLoading = false, twStyle }: InfoBlockProps) => {
  return (
    <div
      className={className}
      css={[
        tw`bg-secondary rounded-none md:rounded-2xl p-5`,
        isContentLoading && tw`flex items-center justify-center`,
        twStyle
      ]}
    >
      {isContentLoading ? <Ring color='var(--primary-color)' /> : children}
    </div>
  )
}

export default InfoBlock
